<template>
    <div>
      <div class="row justify-content-center">
                          <div class=" col-sm-12 grid-margin stretch-card">

                            <div class="card">
                              <div class="card-tile text-center p-2"><h2 class="">Messages</h2></div>
                              <div class="card-body text-center">
                                <div class="mb-3 row justify-content-center">
                                  <div class="col-sm-6 float-right">
                                  <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">

                                  </div>
                                   <div class="col-sm-4 float-right">
                                    <!-- <a class="btn btn-success" v-on:click="showModal()">Add Record</a> -->
                                   </div>
                                </div>
                                <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr class="text-center">
                          <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                          <th class="text-uppercase  text-xxs font-weight-bolder  ">Name</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Subject</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Message</th>
                           <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                           <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center" v-bind:class = "(data.status)?'bg-default':'bg-secondary'">
                          <td>
                            {{index+1}}
                          </td>
                          <td>
                            {{data.name}}
                          </td>
                          <td>
                            {{data.phone}}
                          </td>

                          <td >
                            {{data.subject}}
                          </td>
                           <td >
                            <a href="#" v-on:click="viewMessage(data.id)" data-toggle="tooltip" data-placement="top" title="Click to View"><i class="fa fa-envelope fa-2x text-success"></i></a>
                          </td>
                          <td >
                         {{ data.status }}
                          </td>

                          <td >
                           {{formatDate(data.created_at)}}
                          </td>


                        </tr>

                      </tbody>
                    </table>
                  </div>
                  <div class="row mt-4 justify-content-center">
                        <div class="col-sm-12">
                            <jw-pagination :items="logs"  @changePage="onChangePage" ></jw-pagination>
                        </div>
                    </div>

                              </div>
                            </div>




                            </div>
                            </div>
                            <div class="modal fade" id="message" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body p-5">
         <div class="form-group mt-3">
                    <label class="form-label">Message</label>
                    <textarea v-model="message.message" class="form-control" rows="8"></textarea>
                  </div>

      </div>

    </div>
  </div>
</div>
    </div>
    </template>
    <script>
        import moment from 'moment'
        export default {
            name: 'App',
            components: {

            },
            data(){
                return {
                logs:[],
                 logs2:[],
                message:{message:''},
                pageOfItems:[],

                }
            },
            created(){
                  this.getMessages();
            },
            methods: {
                onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
        viewMessage(id){
            this.$loading(true)
            let uri =`/api/auth/viewMessage/${id}`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                        this.message=response.data;
                        $('#message').modal('show');
                        this.getMessages();
                    }).catch(error => {
                        this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
        },

                 getMessages(){

                    let uri =`/api/auth/getMessages`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {

                     this.logs=response.data;
                     this.logs2=response.data;
                    }).catch(error => {

                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
                },

               filter(){
                let filterval=this.message.filterval;
                if(filterval==='' || filterval===null){
                    this.logs=this.logs2;
                }else{
                    let ads =  this.logs2.filter(function(product) {
                        return   product.phone.toLowerCase().includes(filterval.toLowerCase()) || product.name.toLowerCase().includes(filterval.toLowerCase())
                    });
                    this.logs=ads;
                }
            },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                formatDate(date){
                    return moment(String(date)).format('MM/DD/YYYY HH:mm')
                }

            },
        }

    </script>
